import { ApiType } from "@gymflow/common";
import { useQuery, UseQueryOptions } from "@tanstack/react-query";

import { stripeQueryKeys } from "./stripeQueryKeys";

export function useQueryStripeAccountSession(
  {
    api,
    clubId,
  }: {
    api: ApiType;
    clubId: number;
  },
  queryOpts?: Omit<UseQueryOptions<string>, "queryKey">,
) {
  return useQuery({
    queryKey: stripeQueryKeys.accountSession(),
    queryFn: async () => {
      const result = await api.clubApi.stripeSession(clubId);
      return result.data;
    },
    ...queryOpts,
  });
}
